/****************************************************
 * Module Name:  userSettingsMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import UsersettingsProxy from "../../utility/proxy/manager/usersettingsProxy";
import AddUsersettingsModalWrapper from "./addUsersettingsModalWrapper";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, CircularProgress, Tooltip } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import renderCellExpand from "../common/dataGridCellExpand";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class UsersettingsMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      usersettings: [],
      showAddUsersettingsModal: false,
      accesDenied: false,
      sourceData: {},
      errorSnackbar: false,
      showUsersettingsLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.SETTING_USERSETTING
      ),
    };

    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("SETTING_USERSETTING");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchUsersettingsData(false);
    }
  }

  fetchUsersettingsData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showUsersettingsLoadSpinner: true });
    UsersettingsProxy.GetAllUsersettingsDetail((responseData) => {
      if (responseData) {
        this.setState({
          usersettings: responseData,
          showUsersettingsLoadSpinner: false,
        })
      } else {
        this.setState({
          errorSnackbar: true,
          showUsersettingsLoadSpinner: false,
        })

      }
    }
    );
  };

  columns = [
    {
      field: "userid",
      hheaderName: "USER ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 50,
    },
    {
      field: "username",
      headerName: "USERNAME",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "memoperioddays",
      headerName: "MEMO PERIOD DAYS",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 100,
    },
    {
      field: "paymentperioddays",
      headerName: "PAYMENT DAYS",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 100,
    },
    {
      field: "maxallowedamount",
      headerName: "MAXIMUM ALLOWED MEMO AMOUNT",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 100,
    },
    {
      field: "memoreminderperioddays",
      headerName: "MEMO REMINDER PERIOD DAYS",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 100,
    },
    {
      field: "paymentreminderperioddays",
      headerName: "PAYMENT REMINDER DAYS",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 100,
    },
    {
      field: "stocksearchcriteria",
      headerName: "STOCK SEARCH CRITERIA",
      headerAlign: "center",
      align: "center",
      flex: 3,
      minWidth: 400,
      renderCell: renderCellExpand,
    },
    {
      field: "openinvoicepdf",
      headerName: "OPEN INVOICE PDF",
      headerAlign: "center",
      align: "center",
      flex: 3,
      minWidth: 400,
      type: "boolean",
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      minWidth: 50,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            onClick={() => {
              this.setState({
                showAddUsersettingsModal: true,
                editOperation: true,
                sourceData: params.row,
              });
            }}
          >
            <BorderColorIcon color="primary" style={{ cursor: "pointer" }} />
          </Box>
        );
      },
    },
  ];

  hideAddUsersettingsModal = () => {
    this.setState({
      showAddUsersettingsModal: false,
    });

    this.fetchUsersettingsData(true);
  };

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
          {this.state.showUsersettingsLoadSpinner ? (
            <CircularProgress size="1.2rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchUsersettingsData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}

          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      );
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.usersettings;
    const columns = Utility.isUpdateAllowed(this.state.local_Permission)
      ? this.columns
      : this.columns.filter((col) => col.field !== "edit");
    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        <br />
        {this.state.showAddUsersettingsModal ? (
          <AddUsersettingsModalWrapper
            Show={true}
            loadData={false}
            username={undefined}
            handleClose={this.hideAddUsersettingsModal}
            sourceData={this.state.sourceData}
          />
        ) : (
          <Box />
        )}
        <Box px={1} sx={{ mt: 1 }}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "85vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              slots={{ toolbar: CustomToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.userid}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns userid, the other columns will remain visible
                    userid: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },


                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              loading={this.state.showUsersettingsLoadSpinner}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

export default UsersettingsMaster;
